module.exports = __webpack_public_path__ + "img/logo.81c7a745.png";